import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { GetFullURL } from "./../../../CommonComponents/GlobalConfFiles/URLs";
import { useFetch } from "../../../hooks/useFetch";
import { useMessage } from "../../../hooks/UseMessage";
import OverviewInput from "../../../CommonComponents/InitialInput/OverviewInput"
import OverviewButtons from "./Components/OverviewButtons";
import { LoadingScreen } from "../../../CommonComponents/LoadingScreen/index";
import ListModal from "../../../CommonComponents/Modal/DropDownModal/DropDownListMUI";
import CircleButton from "../../../CommonComponents/CircleButton";
import MessageLog from "../../../CommonComponents/Messages/MessageLog";
import cardlogo from "../../../Assets/cardLogo.svg"

function AccountOverview() {
  let navigate = useNavigate();

  const [account, setAccount] = useState();
  const [showAccountList, setShowAccountList] = useState(false);
  const [_createErrorMessage, _errorMessages, _setErorMessages] = useMessage();

  const [_getAccountList, _accountList, , , , , , _loadingtAccountList] =
    useFetch(GetFullURL("AccountList"), { method: "POST" });

  const [_getAccountExists, , , , , , , _loadingtAccountExist] = useFetch(
    GetFullURL("AccountExist"),
    { method: "POST" }
  );

  function clearMessages(e) {
    e.stopPropagation();
    let type = e.target.dataset.type;
    switch (type) {
      case "success":
        break;
      case "error":
        _setErorMessages([]);
        break;
      case "warning":
      default:
        break;
    }
  }
  const operationLoading = _loadingtAccountExist || _loadingtAccountList;
  return (
    <section className="heroCard heroPartner">
      {operationLoading && <LoadingScreen />}
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="cardHeader">
                <h2>
                  <span>
                  <img src={require("../../../Assets/icon/account.png")} className="img-fluid cardLogo" alt="" />
                  </span>
                  Account Overview
                </h2>
              </div>
              <div className="cardBody">
                <div className="cardInput">
                  <OverviewInput
                    setDocument={setAccount}
                    document={account}
                    placeholder="Account id here..."
                  />
                </div>
                <div className="cardButton">
                  <CircleButton
                    buttonText={`List of Accounts`}
                    clickHandler={() => {
                      _getAccountList({}, () => {
                        setShowAccountList(true);
                      });
                    }}
                  />
                  <OverviewButtons
                    account={account}
                    navigate={navigate}
                    _getAccountExists={_getAccountExists}
                    _createErrorMessage={_createErrorMessage}
                  />
                </div>
              </div>
            </div>
            <MessageLog
              errorMessages={[..._errorMessages]}
              successMessages={[]}
              warningMessages={[]}
              clearMessages={clearMessages}
            ></MessageLog>
            <div className="cardAlert">
              <ListModal
                setId={setAccount}
                dataList={_accountList}
                showListModal={showAccountList}
                setShowModal={setShowAccountList}
                title="List Of Accounts"
                columns={[
                  { field: "id", headerName: "Account ID", width: 100 },
                  { field: "accountTypeId", headerName: "Account Type", width: 250 },
                  { field: "accountName", headerName: "Name", width: 350 },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AccountOverview;
